export default "__VITE_ASSET__803c09bc__"